import _ from 'lodash'
import WktFactory from 'legacy/libs/wicket'
import { dehydrate as temporaryFileDehydrate } from './temporary-file'
import api, { formCfg } from './api'
import apiFactory from './api-factory'

const region = {
  ...apiFactory(
    '/api/gis_regions/region/',
    ['getList', 'getDetail', 'create', 'update'],
    { hydrate, dehydrate }
  ),

  getCompletedList(params, context) {
    return api
      .get('/api/gis_regions/region/completed/', formCfg(params, context))
      .then((response) =>
        _.map(response.data, (rawData) => dehydrate(rawData, params))
      )
  },

  getIntersectsList(params, context) {
    return api
      .get('/api/gis_regions/region/intersects/', formCfg(params, context))
      .then((response) =>
        _.map(response.data, (rawData) => dehydrate(rawData, params))
      )
  },

  validate(data, params, context) {
    return api
      .post(
        '/api/gis_regions/region/validate/',
        hydrate(data),
        formCfg(params, context)
      )
      .then((response) => dehydrate(response.data))
      .catch((error) => {
        // It is coincidence that backend's keys and client's keys are same
        throw error.response.data
      })
  },

  checkChangePermission(pk, params, context) {
    return api.get(
      `/api/gis_regions/region/${pk}/check_change_permission/`,
      formCfg(params, context)
    )
  },

  getLastSearchedRegions(params, context) {
    return api
      .get('/api/gis_regions/search_request_region/', formCfg(params, context))
      .then((response) => response.data)
  },

  getMapRequests() {
    return api
      .get('/api/gis_regions/region/map_requests/')
      .then(({ data }) => data)
  },

  getTagSuggestions() {
    return api
      .get('/api/gis_regions/region/tag_suggestions/')
      .then(({ data }) => data)
  },

  simplifyGeometry(pk) {
    return api
      .get(`/api/gis_regions/region/${pk}/simplify/`)
      .then(({ data }) => data)
  },
}

function addSearchWkt(wkt, searchWkt) {
  if (!searchWkt) {
    return wkt
  }

  const Wkt = WktFactory()
  const wktInstance = new Wkt(wkt)

  wktInstance.merge(new Wkt(searchWkt))

  return wktInstance.write()
}

export function dehydrateAndPopulate(
  { pk, name, description, additionalInfo, tags, wkt, img },
  { gisTagsByPk }
) {
  return {
    pk,
    name,
    description,
    additionalInfo,
    tags: _.compact(_.map(tags, (tagPk) => gisTagsByPk[tagPk])),
    wkt,
    img,
  }
}

export function dehydrate(
  { pk, name, description, additionalInfo, tags, files, wkt, centroid, img },
  params = {}
) {
  const [mapFiles, imageFiles] = _.partition(
    _.map(files, temporaryFileDehydrate),
    (file) =>
      _.includes(
        ['prj', 'shp', 'kml', 'shx', 'dbf', 'sbn', 'sbx'],
        file.extension
      )
  )

  return {
    pk,
    name,
    description,
    additionalInfo,
    tags,
    files: mapFiles,
    images: imageFiles,
    wkt: addSearchWkt(wkt, params.wkt),
    centroid,
    img,
  }
}

export function hydrate({
  pk,
  upload,
  name,
  description,
  wkt,
  files,
  tags,
  additionalInfo,
  forEntry,
}) {
  return {
    pk,
    name,
    description,
    additionalInfo,
    wkt,
    upload,
    tags: _.map(tags, 'pk'),
    files: _.compact(_.map(files, 'pk')),
    forEntry,
  }
}

export default region
